var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse2, _path15, _path16, _path17, _path18, _path19, _ellipse3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle, _circle2, _circle3, _circle4, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlower2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 183,
    viewBox: "0 0 152 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.801 76.294L143.12 75.4313L143.44 76.294L145.08 80.7261L149.512 82.3662L150.374 82.6854L149.512 83.0046L145.08 84.6446L143.44 89.0768L143.12 89.9395L142.801 89.0768L141.161 84.6446L136.729 83.0046L135.866 82.6854L136.729 82.3662L141.161 80.7261L142.801 76.294Z",
    fill: "#FF5500",
    stroke: "black",
    strokeWidth: 0.680752
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3831 122.985L20.7023 122.123L21.0215 122.985L22.6616 127.418L27.0937 129.058L27.9564 129.377L27.0937 129.696L22.6616 131.336L21.0215 135.768L20.7023 136.631L20.3831 135.768L18.7431 131.336L14.3109 129.696L13.4482 129.377L14.3109 129.058L18.7431 127.418L20.3831 122.985Z",
    fill: "#FF5500",
    stroke: "black",
    strokeWidth: 0.680752
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3174 60.7251L117.22 60.1562C116.842 66.7026 116.446 70.3456 114.376 76.6515C88.638 82.9083 68.3864 82.7462 37.7302 77.5047C35.8012 71.8459 35.0648 68.1228 34.3174 60.7251Z",
    fill: "#ECEFF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.078 62.9989C117.078 71.2451 98.8805 78.0722 75.5555 78.0722C52.2306 78.0722 34.3174 69.5387 34.3174 61.2925C34.3174 53.0463 52.0924 50.3431 75.5555 49.3477C106.555 52.0495 117.505 52.4761 117.078 62.9989Z",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7305 77.0762C67.3555 82.559 84.0744 82.4719 114.092 77.0762C112.137 100.002 108.439 125.851 106.022 129.833C77.4395 137.654 63.1174 136.968 44.6983 129.264C40.8504 109.361 39.3592 97.8974 37.7305 77.0762Z",
    fill: "#FF80AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3511 40.0435C34.6988 42.0041 33.8689 43.774 30.149 46.3311C26.4292 48.8881 20.6103 49.1218 19.2625 47.1612C17.9148 45.2006 20.4554 43.6806 24.1753 41.1235C27.8952 38.5665 32.0033 38.0829 33.3511 40.0435Z",
    fill: "#C4C4C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3916 58.0234H28.63C29.9098 67.6931 33.5274 74.1679 38.4419 83.7617L40.0061 99.8304C31.085 91.6942 25.786 81.9131 18.3916 58.0234Z",
    fill: "#ECEFF1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9741,
    cy: 54.609,
    rx: 5.68802,
    ry: 2.98621,
    transform: "rotate(20.1046 15.9741 54.609)",
    fill: "#ECEFF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8184 48.9698C18.8184 53.2893 17.1167 55.0838 12.5616 55.0838C8.00657 55.0838 3.03418 49.4489 3.03418 45.1295C3.03418 40.8101 6.01577 41.1488 10.5708 41.1488C15.1258 41.1488 18.8184 44.6504 18.8184 48.9698Z",
    fill: "#ECEFF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1509 39.2506C35.4986 41.2112 35.9051 44.9433 32.1852 47.5004C28.4653 50.0574 21.4101 48.3289 20.0623 46.3683C18.7146 44.4077 21.2552 42.8876 24.9751 40.3306C28.695 37.7735 32.8031 37.29 34.1509 39.2506Z",
    fill: "#ECEFF1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5429 30.1974C18.9603 37.308 21.1629 42.7706 17.8095 44.3131C14.4561 45.8557 10.0016 43.7072 7.82586 36.312C5.06896 30.3188 4.47249 24.1521 7.82587 22.6096C11.1792 21.067 13.786 24.2042 16.5429 30.1974Z",
    fill: "#ECEFF1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2897 30.2212C30.2897 43.109 28.0138 43.4425 23.5115 43.109C19.0091 42.7756 18.319 38.9382 20.241 31.432C20.7283 24.853 20.241 20.4823 23.5114 19.0317C28.0138 19.3652 29.0573 21.9047 30.2897 30.2212Z",
    fill: "#ECEFF1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9713 51.1967C28.0611 60.2976 30.3516 64.9902 24.9327 64.9902C19.5137 64.9902 18.9602 55.3206 10.3477 51.1967C10.3477 42.5579 14.7406 35.5547 20.1595 35.5547C25.5784 35.5547 29.9713 42.5579 29.9713 51.1967Z",
    fill: "#ECEFF1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.293 58.9766H121.344C120.064 68.6462 117.157 75.121 112.243 84.7149L110.678 100.784C119.6 92.6473 124.899 82.8662 132.293 58.9766Z",
    fill: "#ECEFF1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.775 88.1676L118.074 71.1035C115.798 80.2043 111.185 84.1196 106.271 93.7134C105.565 98.4042 106.408 100.281 109.542 102.672C117.789 93.9978 111.675 102.245 120.775 88.1676Z",
    fill: "#ECEFF1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.0189,
    ry: 3.2969,
    transform: "matrix(-0.939067 0.343735 0.343735 0.939067 134.507 55.9696)",
    fill: "#ECEFF1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131.877 50.485C131.877 54.8045 133.578 56.599 138.133 56.599C142.688 56.599 146.808 51.5287 146.808 47.2093C146.808 42.8898 143.669 42.2371 139.271 43.2286C134.716 43.2286 131.877 46.1656 131.877 50.485Z",
    fill: "#ECEFF1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.89 41.2388C114.542 43.1994 114.136 46.9316 117.856 49.4886C121.576 52.0457 128.631 50.3171 129.979 48.3565C131.326 46.3959 128.786 44.8759 125.066 42.3188C121.346 39.7618 117.238 39.2782 115.89 41.2388Z",
    fill: "#ECEFF1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.142 31.1496C131.725 38.2602 129.522 43.7228 132.876 45.2653C136.229 46.8079 140.683 44.6594 142.859 37.2642C145.616 31.2709 145.601 26.005 142.248 24.4625C138.894 22.9199 136.899 25.1563 134.142 31.1496Z",
    fill: "#ECEFF1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M121.202 31.8568C117.22 45.5079 122.672 44.3977 127.174 44.0643C131.677 43.7308 130.871 40.3886 131.156 31.8568C130.668 25.2779 132.009 22.6428 128.738 21.1922C124.615 22.187 122.434 23.5403 121.202 31.8568Z",
    fill: "#ECEFF1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.206 52.1506C120.491 57.1681 120.333 65.944 125.752 65.944C131.171 65.944 131.724 56.2744 140.337 52.1506C140.337 43.5117 136.148 38.1133 130.729 38.1133C125.31 38.1133 120.206 43.5117 120.206 52.1506Z",
    fill: "#ECEFF1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.5863,
    cy: 176.267,
    rx: 1.70641,
    ry: 4.04638,
    fill: "#ECEFF1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.632 163.978C116.366 173.719 112.812 182.112 104.137 182.711C95.4627 183.311 100.298 171.321 99.0177 164.577C77.1186 155.735 96.3896 149.891 106.128 149.891C119.068 152.288 121.058 153.787 120.632 163.978Z",
    fill: "#ECEFF1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6875 136.552L96.6002 135.652C97.5956 148.391 107.55 150.339 116.935 152.287L94.7516 162.778C84.6517 160.454 81.1536 154.154 77.6875 136.552Z",
    fill: "#ECEFF1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1892 170.219C58.7764 176.476 59.0608 179.604 52.6618 182.732C41.981 182.732 30.4785 173.324 30.4785 166.806C31.1895 159.98 42.9922 163.962 46.6894 160.691C57.3702 160.691 62.1892 163.7 62.1892 170.219Z",
    fill: "#ECEFF1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0733 133.814L71.7154 140.924L61.1926 171.782L46.5459 160.69L56.0733 133.814Z",
    fill: "#ECEFF1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.454 77.0907C67.7379 86.3899 37.7607 76.8613 37.7607 76.8613C37.7607 76.8613 40.9386 116.076 44.6054 128.71C44.8132 129.11 45.1394 129.436 45.5395 129.644C49.6677 131.697 75.827 141.42 105.879 129.442C108.664 125.822 110.748 107.428 111.702 100.76M114.176 77.0907C114.172 77.7789 113.697 80.0815 113.619 81.2677",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8741 99.6719C39.8741 99.6719 26.289 89.1887 19.3873 60.7618C19.2022 59.9637 18.7853 59.238 18.1891 58.6761C17.5929 58.1141 16.8439 57.7409 16.0362 57.6032C14.653 57.3965 12.7404 56.7078 10.3447 54.5332",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8266 53.7909C19.027 51.4494 18.01 46.9192 14.5551 43.6726C11.1002 40.4259 6.51562 39.6922 4.31522 42.0337C2.11483 44.3752 3.13183 48.9054 6.58675 52.152C10.0417 55.3987 14.6262 56.1324 16.8266 53.7909Z",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50587 40.8529C9.37754 39.6408 1.61309 26.8854 8.0799 22.5576C14.5467 18.2297 17.1491 36.9386 19.1098 36.0402C21.0706 35.1418 17.9263 19.5274 24.4858 18.9285C31.0453 18.3296 30.3964 36.5892 30.3109 37.8084C30.2253 39.0276 16.1723 41.3235 19.3594 46.5568C22.5464 51.7901 33.2555 48.5175 34.9738 44.6816C36.6921 40.8457 32.1932 37.3735 30.1754 38.0223",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2171 48.3203C30.0904 50.7165 29.6097 55.8611 28.7908 58.1166C27.6084 61.5574 36.12 78.5697 38.2242 82.6882",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110.397 59.8244C110.397 60.2214 110.219 60.6465 109.804 61.101C109.386 61.5579 108.75 62.0197 107.894 62.4731C106.182 63.3797 103.676 64.2094 100.543 64.9113C94.2836 66.3134 85.615 67.1844 76.0252 67.1844C66.4354 67.1844 57.7669 66.3134 51.5075 64.9113C48.3743 64.2094 45.8685 63.3797 44.1568 62.4731C43.3005 62.0197 42.6641 61.5579 42.2467 61.101C41.8315 60.6465 41.6539 60.2214 41.6539 59.8244C41.6539 59.4275 41.8315 59.0023 42.2467 58.5479C42.6641 58.0909 43.3005 57.6292 44.1568 57.1757C45.8685 56.2692 48.3743 55.4394 51.5075 54.7376C57.7669 53.3355 66.4354 52.4644 76.0252 52.4644C85.615 52.4644 94.2836 53.3355 100.543 54.7376C103.676 55.4394 106.182 56.2692 107.894 57.1757C108.75 57.6292 109.386 58.0909 109.804 58.5479C110.219 59.0023 110.397 59.4275 110.397 59.8244Z",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.692 62.7492C105.692 62.786 105.656 62.9405 105.278 63.1839C104.923 63.4118 104.371 63.6479 103.619 63.8816C102.122 64.347 99.9325 64.7722 97.2009 65.1312C91.7438 65.8486 84.1916 66.2937 75.8405 66.2937C67.4894 66.2937 59.9371 65.8486 54.4801 65.1312C51.7484 64.7722 49.5592 64.347 48.0617 63.8816C47.3098 63.6479 46.7582 63.4118 46.4034 63.1839C46.0245 62.9405 45.9889 62.786 45.9889 62.7492C45.9889 62.7124 46.0245 62.5579 46.4034 62.3145C46.7582 62.0866 47.3098 61.8505 48.0617 61.6168C49.5592 61.1514 51.7484 60.7262 54.4801 60.3671C59.9371 59.6498 67.4894 59.2047 75.8405 59.2047C84.1916 59.2047 91.7438 59.6498 97.2009 60.3671C99.9325 60.7262 102.122 61.1514 103.619 61.6168C104.371 61.8505 104.923 62.0866 105.278 62.3145C105.656 62.5579 105.692 62.7124 105.692 62.7492Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.08 59.8259C117.08 61.0398 116.099 62.3185 114.01 63.5698C111.948 64.8046 108.936 65.9319 105.175 66.8846C97.6606 68.7883 87.2559 69.9706 75.7467 69.9706C64.2375 69.9706 53.8327 68.7883 46.3181 66.8846C42.5574 65.9319 39.5452 64.8046 37.4837 63.5698C35.3945 62.3185 34.4137 61.0398 34.4137 59.8259C34.4137 58.612 35.3945 57.3333 37.4837 56.082C39.5452 54.8472 42.5574 53.7199 46.3181 52.7672C53.8327 50.8635 64.2375 49.6812 75.7467 49.6812C87.2559 49.6812 97.6606 50.8635 105.175 52.7672C108.936 53.7199 111.948 54.8472 114.01 56.082C116.099 57.3333 117.08 58.612 117.08 59.8259Z",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.079 59.8672C116.801 64.6011 115.958 74.1932 114.176 77.0893M34.4092 59.8748C34.7805 64.5159 36.1356 74.6638 37.9178 77.1143",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7687,
    cy: 97.3565,
    r: 1.68858,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.12,
    cy: 100.666,
    r: 2.09758,
    fill: "#CCFF90"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.8017,
    cy: 101.865,
    r: 2.09758,
    fill: "#CCFF90"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.9054,
    cy: 97.673,
    r: 1.68858,
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4575 102.871C58.6372 108.919 64.6325 107.489 64.8496 103.208",
    stroke: "black",
    strokeWidth: 0.995403,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9668 133.246C55.8208 133.932 55.4095 134.906 55.2013 135.578C54.6957 137.208 54.0802 138.788 53.5752 140.418C51.9623 145.621 50.1787 150.656 48.2011 155.727C47.5495 157.398 46.7689 159.865 44.9811 160.638C39.9773 162.801 30.3905 157.795 30.5839 166.925C30.8068 173.599 50.5475 186.454 55.9895 179.747C61.9085 172.863 68.611 150.292 72.8887 135.379",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M77.582 135.376C79.3173 147.094 83.8086 154.211 84.2008 154.752C86.6221 158.095 88.5077 159.589 92.2573 161.015C94.0907 161.711 97.164 161.524 98.5501 163.148C99.4109 164.156 99.5532 166.052 99.3615 167.327C98.6659 171.944 95.8096 176.52 99.8552 180.363C100.773 181.236 102 181.94 103.282 181.874C104.414 181.815 105.458 181.567 106.52 181.133C107.986 180.534 109.33 179.844 110.556 178.806C115.812 174.352 124.088 160.588 119.449 153.447C116.745 149.285 107.067 149.25 102.808 146.474C100.891 145.224 99.4644 143.444 98.6615 141.28C98.4238 140.641 98.1918 140.013 98.0787 139.336C98.0566 139.205 97.4014 137.996 96.1745 132.961",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8252 133.389L72.7119 135.557L70.1523 144.231C64.1799 135.842 61.6554 137.228 55.8252 133.389Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0323 133.141L98.4497 140.251C90.8069 136.835 86.2889 135.931 77.6885 135.558L96.0323 133.141Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M55.833 88.9902L59.0169 91.8224",
    stroke: "black",
    strokeWidth: 0.995403,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5342 89.252L65.278 92.0007",
    stroke: "black",
    strokeWidth: 0.995403,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.72 102.711C109.72 102.711 123.862 91.1136 130.763 62.6868C130.949 61.8886 131.365 61.163 131.962 60.6011C132.558 60.0391 133.307 59.6659 134.115 59.5282C135.498 59.3215 137.553 58.6199 139.948 56.4453",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M133.324 55.7128C131.123 53.3712 132.14 48.8411 135.595 45.5944C139.05 42.3478 143.635 41.614 145.835 43.9556C148.036 46.2971 147.019 50.8273 143.564 54.0739C140.109 57.3206 135.524 58.0543 133.324 55.7128Z",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M140.781 42.9944C140.91 41.7824 148.674 29.027 142.207 24.6991C135.74 20.3713 133.138 39.0801 131.177 38.1818C129.217 37.2834 134.804 21.8596 128.244 21.2607C121.685 20.6617 119.891 38.7308 119.976 39.95C120.062 41.1692 131.975 40.3528 130.928 48.6983C126.881 53.8372 118.056 50.9264 115.313 46.8232C114.16 44.6337 116.693 39.1542 120.112 40.1639",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M119.815 50.6289C119.942 53.025 119.762 55.8999 120.58 58.1553C122.53 68.7371 107.771 91.293 107.771 91.293C104.991 94.4622 105.02 99.9796 109.684 102.71",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M109.185 22.4972C106.056 31.598 97.6542 39.154 87.8546 37.1438C76.763 34.8686 77.7584 37.4565 77.7584 28.8962C82.451 18.6581 87.8546 7.70869 106.483 8.70374C115.015 8.27735 109.185 16.0982 109.185 22.4972Z",
    fill: "#CCFF90"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1256 4.00992C60.1256 5.42355 58.2793 6.56953 56.0017 6.56953C53.7242 6.56953 51.8779 5.42355 51.8779 4.00992C53.4421 0.312491 53.7242 1.45031 56.0017 1.45031C65.387 3.58314 60.1256 2.59628 60.1256 4.00992Z",
    fill: "#CCFF90"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7497 23.9164C79.7497 36.0108 88.5503 34.4391 75.1993 34.4391C61.8483 34.4391 49.0345 26.7602 50.1721 13.109C53.3004 2.01735 49.7613 2.87064 63.1123 2.87064C70.6489 6.28356 80.4607 13.109 79.7497 23.9164Z",
    fill: "#CCFF90"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6215 33.873L78.7545 34.8685C77.6837 46.7174 77.5662 53.2785 77.9013 64.8728L73.2087 64.1618C72.3698 51.6593 73.0288 45.0046 76.6215 33.873Z",
    fill: "#CCFF90"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4603 34.5612C45.3099 34.404 47.9491 12.125 53.3809 1C74.5227 3.58041 80.0136 15.5929 80.0165 25.5716",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M110.855 9.63912C111.325 22.1662 105.416 44.7401 78.0279 34.819C78.7269 24.2485 86.2709 4.41378 110.855 9.63912Z",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7899 17.3731C99.0153 17.2868 99.1281 17.0341 99.0419 16.8087C98.9556 16.5832 98.7029 16.4704 98.4774 16.5567L98.7899 17.3731ZM93.7801 18.9237C93.5742 19.0497 93.5095 19.3188 93.6355 19.5247C93.7616 19.7306 94.0307 19.7953 94.2366 19.6692L93.7801 18.9237ZM90.7959 22.0151C90.9964 21.8806 91.0499 21.6091 90.9154 21.4086C90.7809 21.2081 90.5094 21.1546 90.3089 21.2891L90.7959 22.0151ZM94.2366 19.6692C95.7675 18.7318 97.3025 17.9424 98.7899 17.3731L98.4774 16.5567C96.9281 17.1496 95.3444 17.9658 93.7801 18.9237L94.2366 19.6692ZM78.8382 34.4377C79.8818 32.1123 82.2727 27.733 90.7959 22.0151L90.3089 21.2891C81.6558 27.0941 79.1541 31.5986 78.0407 34.0798L78.8382 34.4377Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M70.411 19.4277C70.2417 19.2557 69.9649 19.2536 69.7929 19.4229C69.6209 19.5923 69.6188 19.8691 69.7882 20.0411L70.411 19.4277ZM78.0566 34.0945C77.4131 31.141 74.9929 24.0803 70.411 19.4277L69.7882 20.0411C74.2068 24.528 76.5763 31.4068 77.2024 34.2806L78.0566 34.0945Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M73.225 64.2123C72.4645 59.2127 72.6032 54.0948 73.1738 49.4535C73.2315 48.9843 73.2936 48.52 73.3596 48.0612C73.4188 47.6499 73.4812 47.243 73.5463 46.8409C74.4005 41.5707 75.7376 37.1341 76.7747 34.5283C77.2025 34.0241 77.6702 34.0741 78.0132 34.2583C78.2906 34.4073 78.3836 34.7393 78.3616 35.0534C78.0506 39.4894 77.8463 43.4048 77.7237 46.8409C77.709 47.2546 77.6954 47.6613 77.683 48.0612C77.6683 48.5349 77.6551 48.999 77.6435 49.4535C77.4602 56.6376 77.6586 61.4412 77.9511 64.3389",
    stroke: "black",
    strokeWidth: 0.874198,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower2);
export default __webpack_public_path__ + "static/media/Flower2.5cfafb1f75f67f788f33a8e64af7c51e.svg";
export { ForwardRef as ReactComponent };